module.exports = __webpack_public_path__ + "static/bottomBlob-e1ab20e78813acf2ddd258c35e625024.png";